import { Logo } from '@motorway/mw-highway-code';
import { LoadingIndicator } from '@motorway/mw-highway-code/alpha';

import styles from './Home.module.scss';

export const Home = ({
  hideLogo = false,
  loading = false,
  error = false,
}) => (
  <div className={styles.component}>
    <div>
      { !hideLogo && <Logo /> }
      { error && <div className={styles.error}>An error occurred</div> }
      <div className={styles.loading}>
        { loading && <LoadingIndicator /> }
      </div>
    </div>
  </div>
);
